import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  translationConstants,
  systemConstants,
  Directions,
  viewPathConstants,
  timezoneConstants,
} from "../../../constants";
import {
  getSingleDateIfEqual,
  moveBack,
  toSingleDateStringIfEqual,
} from "../../../system";
import BTN_BACK from "../../../assets/images/icon/arrow-left.svg";
import { useNavigate } from "react-router-dom";
import ICalendarLink from "react-icalendar-link";
import Calender from "../../../container/views/Calendar/Calendar";

const ActivityDetail = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isRedirectToCalender, setIsRedirectToCalender] = useState(false);
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const icsEvent = {
    title: props?.activityData?.centerActivityInfo?.name,
    description: props?.activityData?.centerActivityInfo?.description,
    startTime: moment(
      props?.activityData?.centerActivityInfo?.startDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    endTime: moment(
      props?.activityData?.centerActivityInfo?.endDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    location: `${props?.activityData?.spotName}`,
  };

  return (
    <div className="row m-0 px-1">
      {props.isBackButtonAllowed ? (
        <div className="d-flex align-items-center py-3">
          <span
            className="cursor-pointer rotated-element"
            onClick={() => setIsRedirectToCalender(true)}
          >
            <img src={BTN_BACK} />
          </span>
        </div>
      ) : (
        ""
      )}
      {isRedirectToCalender ? (
        <Calender />
      ) : (
        <>
          {props?.activityData?.posters.length > 0 && (
            <div className="col-12">
              <img
                alt="info-icon"
                src={props?.activityData?.posters[0]?.link}
                className="w-100 poster-style"
              />
            </div>
          )}
          <div className="col-md-10 pt-3 d-flex flex-column gap-2">
            <h3 className="fw-bolder">
              {direction === Directions.rtl &&
              props?.activityData?.centerActivityInfo?.arabicName
                ? `${props?.activityData?.centerActivityInfo?.arabicName}`
                : `${props?.activityData?.centerActivityInfo?.name}`}
            </h3>
          </div>
          {props?.activityData?.spotName && (
            <div className="col-md-10 d-flex flex-column gap-2">
              <h5 className="text-muted">
                {direction === Directions.rtl &&
                props?.activityData?.spotArabicName
                  ? `${props?.activityData?.spotArabicName}`
                  : `${props?.activityData?.spotName}`}
              </h5>
            </div>
          )}
          <div className="col-md-10 d-flex flex-column gap-2">
            <h5 className="">
              {toSingleDateStringIfEqual(
                props?.activityData?.centerActivityInfo?.startDateString,
                props?.activityData?.centerActivityInfo?.endDateString
              )}
            </h5>
          </div>
          <div className="col-md-10 pt-4 d-flex flex-column gap-2">
            <span className="second-card-heading-text">
              {t(translationConstants.ACTIVITY_LINK)}
            </span>{" "}
            <span className="second-card-description-text text-underline">
              <a
                href={props?.activityData?.centerActivityInfo?.url}
                target="blank"
              >
                {props?.activityData?.centerActivityInfo?.url}
              </a>
            </span>
          </div>
          <div className="col-md-10 py-4 d-flex flex-column gap-2">
            <span className="second-card-heading-text">
              {t(translationConstants.DESCRIPTION)}
            </span>{" "}
            <span className="second-card-description-text">
              {direction === systemConstants.DIRECTION_RIGHT_TO_LEFT &&
              props?.activityData?.centerActivityInfo?.arabicDescription
                ? props?.activityData?.centerActivityInfo?.arabicDescription
                : props?.activityData?.centerActivityInfo?.description}
            </span>
          </div>
          <div className="pb-5">
            <span
              target="_blank"
              disabled={true}
              className="font-14 center-card-view-detail-link approved-color"
            >
              <ICalendarLink
                event={icsEvent}
                filename={props?.activityData?.centerActivityInfo?.name}
              >
                {t(translationConstants.add_to_calendar)}
              </ICalendarLink>
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default ActivityDetail;
